import { useEffect, useState } from "react";

const navLinks = [
  { label: "最新章节", href: "#chapters" },
  { label: "连载进度", href: "#progress" },
  { label: "剧情简介", href: "#story" },
  { label: "主要角色", href: "#characters" },
  { label: "常见问题", href: "#faq" },
  { label: "关于本站", href: "#about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      <nav
        className={`transition-all duration-300 ${
          scrolled || open
            ? "bg-background-50/95 backdrop-blur shadow-[0_1px_0_0_oklch(var(--background-200))]"
            : "bg-transparent"
        }`}
      >
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
          <a href="#top" className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
              <i className="ri-leaf-fill text-lg"></i>
            </span>
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
              天才医仙<span className="text-accent-600">漫画</span>
            </span>
          </a>

          <ul className="hidden items-center gap-8 md:flex">
            {navLinks.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  className="whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-700"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>

          <div className="hidden items-center gap-3 md:flex">
            <span className="flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-700">
              <i className="ri-fire-fill"></i>
              今日已更新
            </span>
            <a
              href="#follow"
              className="whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-700"
            >
              <i className="ri-bookmark-line mr-1.5"></i>收藏追更
            </a>
          </div>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-900 hover:bg-background-200 md:hidden"
          >
            <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
          </button>
        </div>

        {open && (
          <div className="border-t border-background-200 bg-background-50 md:hidden">
            <ul className="space-y-1 px-4 py-4">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    onClick={() => setOpen(false)}
                    className="block rounded-md px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-100"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="#follow"
                  onClick={() => setOpen(false)}
                  className="mt-2 flex items-center justify-center whitespace-nowrap rounded-md bg-primary-600 px-4 py-2.5 text-sm text-background-50"
                >
                  <i className="ri-bookmark-line mr-1.5"></i>收藏追更
                </a>
              </li>
            </ul>
          </div>
        )}
      </nav>
    </header>
  );
}